import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin, Descriptions, message, Modal, Input, Result, Icon } from 'antd';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPrint, faEye } from '@fortawesome/free-solid-svg-icons';
import {
    cashlessUnRemittedViewsAccount,
    setCashlessRemittanceStatus,
} from './ducks';

import PageHeader from '../../components/PageHeader';
import ReactTable from '../../components/ReactTable';
import Card from '../../components/Card';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';

export class ListViews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadSpin: false,
            isReject: false,
            rejectReason: "",
            isVisible: false,
            isChanging:false,
            newStatus:false,
            remittanceStatus:"",
            showEpod: false,
        };
    }

    fetchViewAccount = () => {
        const { urViews, match } = this.props;

        this.setState({ loadSpin: true });

        return urViews(match.params.id)
            .finally(() => {
                this.setState({ loadSpin: false });
            });
    };
    componentDidMount() {
        this.fetchViewAccount();
    }
    showAlertModal(status) {
        const { rejectReason } = this.state;
        if(status == 'reject'){
            if (!rejectReason || !rejectReason.trim()) {
                message.error('Please enter a reason for rejection.');
                return;
            }
        }
        this.setState({
            isVisible: true,
            newStatus:false,
            remittanceStatus:status,
            isReject: false,
        });
    }
    setCashlessRemittanceStatus(dm) {
        const { doCashlessRemittanceStatus } = this.props;
        const { remittanceStatus, rejectReason } = this.state;
        this.setState({
            isChanging: true,
        });
        doCashlessRemittanceStatus(dm, remittanceStatus, {rejectReason})
        .then((action) => {
            this.setState({
                isChanging: false,
                isVisible:false,
                rejectReason:""
            });
            const code = action.payload.data.code;
            const messageText = action.payload.data.message;
            if (code === 200) {
                message.success(messageText);
                return this.fetchViewAccount();
            }
            message.error(messageText);
            return null;
        })
        .catch((error) => {
            this.setState({
                isChanging: false,
                isVisible:false,
                rejectReason:""
            });
            console.error(error);
            message.error(error.error.response.data.message);
        });
    }
    closeReject = () => {
        this.setState({
            isReject: false,
            rejectReason: "",
        });
    };
    showReject = () => {
        this.setState({
            isReject: true,
            rejectReason: "",
        });
    }
    cancelHandler =()=> {
        this.setState({
            isVisible: false,
        });
    }
    closeShowEpod = () => {
        this.setState({
            showEpod: false,
        });
    };
    openShowEpod = () => {
        this.setState({
            showEpod: true,
        });
    };
    inArray(userId, ids) {
    var id = ids.length;
    for(var i = 0; i < id; i++) {
      if(ids[i] == userId) return true;
    }
    return false;
  }
    render() {
        const imageHandler = 'https://img.icons8.com/wired/2x/file-delete.png';
        const { loadSpin, isVisible, isChanging, newStatus } = this.state;
        const { viewAccount, user } = this.props;

        return (
            <div className="ListView">
                <PageHeader
                    title="VIEW CASHLESS-REMITTANCE"
                    extra={[
                        <Button
                            key="remitted"
                            type="primary"
                            onClick={() =>
                                this.openShowEpod()
                            }
                        >
                           Show ePOD
                        </Button>
                    ]}
                />
                <Spacer />
                <Container>
                    <Card>
                        <Spin spinning={loadSpin} tip="Loading Cashless Remittance view...">
                            <Descriptions bordered size="small">
                                <Descriptions.Item label="Dispatch Number">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].dm
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Type">
                                    {viewAccount.remittance ? viewAccount.remittance[0].type : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Dispatch Date">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance.dispatch_date
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Driver">
                                    {viewAccount.remittance ? viewAccount.remittance[0].driver : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Vehicle">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].vehicle_name
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Date Remitted">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].created_date
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Total Amount">
                                    {viewAccount.remittance
                                        ? `₱ ${viewAccount.total_amount
                                            .toFixed(2)
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Processed By">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].created_by_name
                                        : ''}
                                </Descriptions.Item>
                            </Descriptions>
                            <Spacer />
                            {console.log(user)}
                            {this.inArray(user.role_id,[5]) ?
                            (
                                viewAccount.remittance &&
                                viewAccount.remittance[0].remittance_status != 'reject' ? (
                                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showAlertModal('verified')}
                                        >
                                            Verified
                                        </Button>

                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showAlertModal('remitted')}
                                        >
                                            Remitted
                                        </Button>

                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showReject()}
                                        >
                                            Reject
                                        </Button>
                                    </div>
                                ) : null
                            ): ''}
                            {/* <Button
                                type="primary"
                                block
                                style={{ marginTop: 5 }}
                                onClick={() =>
                                    window.open(
                                        `${process.env.REACT_APP_API_URL}/web/cashless-remittance/print/${viewAccount.remittance.id}`,
                                        '_blank'
                                    )
                                }
                            >
                                Print
                            </Button> */}
                        </Spin>
                    </Card>
                    <Spacer />
                    <Card
                        extra={`Total: ${viewAccount.remittance ? viewAccount.remittance.length : 0
                            }`}
                    >
                        <Spin spinning={loadSpin} tip="Loading Cashless Remittance view...">
                            <ReactTable
                                data={viewAccount.remittance}
                                columns={[
                                    {
                                        Header: 'Tracking Number',
                                        accessor: 'tracking_number',
                                    },
                                    {
                                        Header: 'Bank Ref',
                                        accessor: 'bank_ref',
                                    },
                                    {
                                        Header: 'Bank Name',
                                        accessor: 'bank_name',
                                    },
                                    {
                                        Header: 'Amount',
                                        accessor: 'amount',
                                        Cell: ({ value }) =>
                                            `₱${Number(value || 0)
                                                .toFixed(2)
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
                                    },
                                    {
                                        Header: 'Status',
                                        accessor: 'remittance_status',
                                    },
                                ]}
                            />
                        </Spin>
                    </Card>
                </Container>
                <Modal
                    visible={this.state.isReject}
                    onCancel={this.closeReject}
                    footer={null}
                    title="Reject Remittance"
                >
                    <div>
                        <label
                            style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontWeight: 'bold',
                            }}
                        >
                            Reason
                        </label>

                        <Input.TextArea
                            rows={4}
                            placeholder="Enter reason for rejection"
                            value={this.state.rejectReason}
                            onChange={(e) =>
                                this.setState({
                                    rejectReason: e.target.value,
                                })
                            }
                        />

                        <div
                            style={{
                                marginTop: '20px',
                                textAlign: 'right',
                            }}
                        >
                            <Button
                                style={{ marginRight: '8px' }}
                                onClick={this.closeReject}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="danger"
                                disabled={isChanging}
                                onClick={() =>
                                    // this.handleReject(this.state.rejectReason, viewAccount.remittance[0].dm, 'reject')
                                    this.showAlertModal('reject')
                                }
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                </Modal>
                <Modal
                    title="Status Update"
                    closable={false}
                    visible={isVisible}
                    footer={[
                        <Button
                            key="cancel"
                            type="default"
                            onClick={this.cancelHandler}
                            disabled={isChanging}
                        >
                            Cancel
                        </Button>,
                       <Button
                            key="update"
                            type="primary"
                            loading={isChanging}
                            onClick={
                                newStatus === false
                                    ? () => this.setCashlessRemittanceStatus(viewAccount.remittance[0].dm)
                                    : this.cancelHandler
                            }
                        >
                            {newStatus === false ? 'Update' : 'Done'}
                        </Button>
                    ]}
                >
                    <Result
                    status={newStatus === false ? 'info' : 'success'}
                    title={newStatus === false
                        ? `Are you sure you want to update the status?`
                        : 'status update'}
                    />
                </Modal>
                <Modal
                    title="Actual PoD"
                    visible={this.state.showEpod}
                    onCancel={this.closeShowEpod}
                    footer={null}
                >
                    {viewAccount.document && viewAccount.document.length > 0 ? (
                        viewAccount.document.map((doc, index) => (
                            <div key={index} style={{ marginBottom: 20 }}>
                                <img
                                    alt={`POD ${index + 1}`}
                                    style={{ width: '100%' }}
                                    // src={`https://staging-api.xdelogistics.com/${doc.filename}`}
                                    src={`${process.env.REACT_APP_API_URL}/${doc.filename}`}
                                />

                                <Button
                                    block
                                    style={{ marginTop: 10 }}
                                    onClick={() => {
                                        window.open(
                                            `${process.env.REACT_APP_API_URL}/${doc.filename}`,
                                            "_blank"
                                        );
                                    }}
                                >
                                    <Icon viewBox="0 0 1024 1024">
                                        <FontAwesomeIcon icon={faPrint} fixedWidth />
                                    </Icon>
                                    Download POD {index + 1}
                                </Button>
                            </div>
                        ))
                    ) : (
                        <img
                            alt="No POD"
                            style={{ width: '100%' }}
                            src={imageHandler}
                        />
                    )}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    viewAccount: state.cashlessRemittance.listViews,
    user: state.auth.user
});

const mapDispatchToProps = {
    urViews: cashlessUnRemittedViewsAccount,
    doCashlessRemittanceStatus: setCashlessRemittanceStatus,
};

ListViews.propTypes = {
    user: PropTypes.oneOfType([PropTypes.object]).isRequired,
    viewAccount: PropTypes.oneOfType([PropTypes.object]).isRequired,
    urViews: PropTypes.func.isRequired,
    match: PropTypes.oneOfType([PropTypes.object]).isRequired,
    doCashlessRemittanceStatus: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListViews);
